import React from 'react';
import { required, List, SaveButton, Datagrid, DateField, TextField, NumberField, Create, Edit, FormTab, TabbedForm, Toolbar, BooleanInput, TextInput, EditButton, SelectInput, Filter, ArrayInput, SimpleFormIterator, NumberInput } from 'react-admin';

const AdvertiserTitle = ({ record }) => {
    return <span>Advertiser {record ? `"${record.name}"` : ''}</span>;
};

const AdvertiserFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const AdvertiserList = (props) => (
    <List {...props} filters={<AdvertiserFilter />} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="code" label="ID" />
            <TextField source="name" label="Advertiser/Company Name" />
            <TextField source="website" label="Website" />
            <DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
            <EditButton variant="contained" color="primary" />
        </Datagrid>
    </List>
);
export const AdvertiserEdit = (props) => {
    return (<Edit title={<AdvertiserTitle />} {...props}>
        <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="Advertiser Settings">
                <NumberField source="code" label="Advertiser ID" />
                
                <TextInput source="name" label="Advertiser/Company Name" validate={required()} />
                <TextInput source="website" label="Website" validate={required()} />
                <TextInput source="tldomain" label="Top Level Domain" validate={required()} />

            </FormTab>

        </TabbedForm>

    </Edit>
    )
}
export const AdvertiserCreate = (props) => {
    return (<Create title={<AdvertiserTitle />} {...props}>
        <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="Advertiser Settings">
                <NumberField source="code" label="Advertiser ID" />
                
                <TextInput source="name" label="Advertiser/Company Name" validate={required()} />
                <TextInput source="website" label="Website" validate={required()} />
                <TextInput source="tldomain" label="Top Level Domain" validate={required()} />

            </FormTab>

        </TabbedForm>

    </Create>
    )
}
const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <br />
        <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
        <TextField source="updated_name" label="" style={{ padding: '10px' }} />
    </Toolbar>
);
